import { Schema } from "./Schema.js";
import { SchemaPreprocessor } from "./SchemaPreprocessor.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SchemaLoader {
  static async loadSchema(client, options) {
    const existing = this.schemaLoadCache.get(client.apiUrl);
    if (existing !== void 0) {
      return existing;
    }
    const schemaPromise = (async () => {
      const raw = await client.sendRequest(this.schemaQuery, options);
      return new Schema(SchemaPreprocessor.processRawSchema(raw.data.schema));
    })();
    this.schemaLoadCache.set(client.apiUrl, schemaPromise);
    return await schemaPromise;
  }
}
__publicField(SchemaLoader, "schemaLoadCache", /* @__PURE__ */ new Map());
__publicField(SchemaLoader, "schemaQuery", "query {\n  schema {\n    enums {\n      name\n      values\n    }\n    entities {\n      name\n      customPrimaryAllowed\n      unique {\n        fields\n      }\n      fields {\n        __typename\n        name\n        type\n        nullable\n        ... on _Column {\n          enumName\n          defaultValue\n        }\n        ... on _Relation {\n          side\n          targetEntity\n          ownedBy\n          inversedBy\n          onDelete\n          orphanRemoval\n          orderBy {\n            path\n            direction\n          }\n        }\n      }\n    }\n  }\n}");
export {
  SchemaLoader
};
//# sourceMappingURL=SchemaLoader.js.map
